import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import TenantCorporate from "@/pages/TenantCorporate";
import TenantIndividual from "@/pages/TenantIndividual";
import { usePortalBase } from "@/context/PortalContext";

export default function TenantProfile() {
  const base = usePortalBase();
  const [accountType, setAccountType] = useState(null);

  useEffect(() => {
    api.get(`${base}/profile`)
      .then(({ data }) => setAccountType(data.account_type === "corporate" ? "corporate" : "individual"))
      .catch(() => setAccountType("individual"));
  }, [base]);

  if (accountType === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;

  return accountType === "corporate"
    ? <TenantCorporate onIndividual={() => setAccountType("individual")} />
    : <TenantIndividual onCorporate={() => setAccountType("corporate")} />;
}
